import { DropDownList } from "@progress/kendo-react-dropdowns";
import * as React from "react";

export default function dropdownFilterCell(data: any, defaultItem: any) {
  return class extends React.Component<any, any> {
    public render() {
      return (
        <div className="k-filtercell">
          <DropDownList
            data={data}
            onChange={this.handleChange}
            value={this.props.value}
            defaultItem={defaultItem}
          />
          <button
            className="k-button k-button-icon k-clear-button-visible"
            title="Clear"
            disabled={!this.hasValue(this.props.value)}
            onClick={this.clearValues}
          >
            <span className="k-icon k-i-filter-clear" />
          </button>
        </div>
      );
    }

    private hasValue(value: any) {
      return value && value !== defaultItem;
    }

    private clearValues = (event: any) => {
      event.preventDefault();
      this.props.onChange({
        value: "",
        operator: "",
        syntheticEvent: event
      });
    };

    private handleChange = (event: any) => {
      const hasValue = this.hasValue(event.target.value);
      this.props.onChange({
        value: hasValue ? event.target.value : "",
        operator: hasValue ? "eq" : "",
        syntheticEvent: event.syntheticEvent
      });
    };
  };
}
